import {
  Component,
  OnInit,
  ViewChild,
  Input,
  SimpleChanges,
  OnChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { AgGridAngular } from '@ag-grid-community/angular';
import { DecimalCellRenderer } from 'app/utils/ag-grid.locale';
import * as _ from 'lodash';

@Component({
  selector: 'app-payroll-ana2-cash',
  templateUrl: './payroll-ana2-cash.component.html',
  styleUrls: ['./payroll-ana2-cash.component.scss'],
})
export class PayrollAna2CashComponent implements OnInit, OnChanges {
  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public defaultColDef;
  public statusBar;
  public rowBuffer;
  public localeText;
  public modules;

  @Input() ana2Rows: any[];
  @Input() years: string[];

  @Input() ana2Checked: any[];
  @Input() cubeResultat: any[];
  @Input() costPay: any;
  @Input() percentageByTimeline: { [timeline: string]: number };

  ana2Map: any = {};
  costPayTotal = {};

  @Output() ccpName = new EventEmitter();

  @ViewChild('agGrid', { static: false }) agGrid: AgGridAngular;

  constructor(protected store: Store<AppState>) {
    this.modules = AllModules;
  }

  ngOnInit(): void {
    this.ana2Rows = _.cloneDeep(this.ana2Rows).map((ana2) => {
      this.ana2Map[ana2.choice] = [];
      ana2.choice = 'RH ' + ana2.choice;
      return ana2;
    });
  }

  ngOnChanges(simpleChange: SimpleChanges): void {
    if (simpleChange.years && simpleChange.years.previousValue) {
      this.onGridReady(this.agGrid);
      setTimeout(() => {
        this.autoSizeAll(this.agGrid);
      }, 1000);
    }

    if (simpleChange.cubeResultat) {
      if (this.cubeResultat) {
        this.ana2Checked = _.filter(this.ana2Checked, (a) => {
          if (this.ana2Map[a.name]) {
            this.ana2Map[a.name].push(a);
          }
          return a.groups && a.groups.indexOf(this.costPay.key) > -1;
        });

        this.ccpName.emit(this.ana2Checked[0] ? this.ana2Checked[0].name : '-');

        this.cubeResultat.forEach((resultat) => {
          if (
            this.ana2Checked[0] &&
            this.ana2Checked[0].name === resultat.ana2Name
          ) {
            if (!this.costPayTotal.hasOwnProperty(resultat.timeline)) {
              this.costPayTotal[resultat.timeline] = 0;
            }
            this.costPayTotal[resultat.timeline] += resultat.flux;
          }
        });

        if (this.agGrid) {
          this.onGridReady(this.agGrid);
        }
      }
    }
  }

  getColumnDefs(): any[] {
    return [
      {
        headerName: '',
        field: 'choice',
        pinned: 'left',
        width: 75,
      },
    ];
  }

  onGridReady(params): void {
    this.gridApi = params.api;
    this.columnDefs = this.getColumnDefs();

    // Column start timeline
    let colCountPosition = 0;

    // Add timeline
    this.years.forEach((selectedYear) => {
      colCountPosition++;
      // Add flux to column
      this.columnDefs.push({
        headerName: selectedYear,
        children: [],
      });

      this.columnDefs[colCountPosition].children.push({
        headerName: 'Total',
        field: 'totalFlux' + selectedYear,
        cellClass: ({ data }) => {
          // if (data && data.sumTimeline < 0) {
            // return ['ag-numeric-cell', 'negative-flux'];
          // }
          return ['ag-numeric-cell'];
        },
        cellRenderer: DecimalCellRenderer,
        aggFunc: 'sum',
        valueGetter: ({ data }) => {
          let total = 0;
          data.items.forEach((item, index) => {
            if (item.timeline.indexOf(selectedYear) > -1) {
              const percent =
                (data.items[index].value /
                  this.percentageByTimeline[item.timeline]) *
                100;

              total = (percent * this.costPayTotal[item.timeline]) / 100;
            }
          });
          data.sumTimeline = total;
          return total;
        },
        width: 100,
        columnGroupShow: 'open',
      });
      new Array(12).fill(0).forEach((d, index) => {
        const timelineKey = `${selectedYear}-${
          index < 9 ? '0' + (index + 1) : index + 1
        }`;
        this.columnDefs[colCountPosition].children.push({
          headerName: timelineKey,
          width: 100,
          columnGroupShow: 'closed',
          cellClass: ({ data }) => {
            if (data && data.total < 0) {
              // return ['ag-numeric-cell', 'negative-flux'];
            }
            return ['ag-numeric-cell'];
          },
          cellRenderer: DecimalCellRenderer,
          aggFunc: 'sum',
          valueGetter: ({ data }) => {
            let res = null;
            if (data) {
              // tslint:disable-next-line: no-shadowed-variable
              const index = _.findIndex(
                data.items,
                ({ timeline }) => timeline === timelineKey
              );

              if (index > -1) {
                const percent =
                  (data.items[index].value /
                    this.percentageByTimeline[timelineKey]) *
                  100;

                res = (percent * this.costPayTotal[timelineKey]) / 100;
                data.total = res;
              }
            }
            return res;
          },
        });
      });
    });

    this.gridColumnApi = params.columnApi;
    setTimeout(() => this.autoSizeAll(this.agGrid));
  }

  public clearSearch(): void {
    this.gridApi.setQuickFilter('');
  }

  onFirstDataRendered(params): void {
    setTimeout(() => this.autoSizeAll(params));
  }

  onRowDataUpdated(params): void {
    this.autoSizeAll(params);
  }

  private autoSizeAll(params): void {
    const allColumnIds = params.columnApi
      .getAllColumns()
      .map((column) => column.colId);
    setTimeout(() => params.columnApi.autoSizeColumns(allColumnIds), 0);
  }
}
